import type { HelpArticleListParams } from '../api/help-center-api';

/** Store-scoped keys: switching stores never shares cache. */
export const helpCenterKeys = {
  all: (storeId: string) => ['stores', storeId, 'help'] as const,
  articles: (storeId: string) => [...helpCenterKeys.all(storeId), 'articles'] as const,
  articleLists: (storeId: string) => [...helpCenterKeys.articles(storeId), 'list'] as const,
  articleList: (storeId: string, params: HelpArticleListParams) =>
    [...helpCenterKeys.articleLists(storeId), params] as const,
  articleDetails: (storeId: string) => [...helpCenterKeys.articles(storeId), 'detail'] as const,
  articleDetail: (storeId: string, id: string) =>
    [...helpCenterKeys.articleDetails(storeId), id] as const,
  feedback: (storeId: string, id: string) =>
    [...helpCenterKeys.articleDetail(storeId, id), 'feedback'] as const,
  categories: (storeId: string) => [...helpCenterKeys.all(storeId), 'categories'] as const,
};
